<template>
    <div>
        <loading v-if="loading" msg="正在登录..."></loading>
    </div>
</template>

<script>
    import Loading from "../../components/Loading";
    export default {
        name: "Login",
        components:{
            Loading
        },
        data(){
            return {
                loading: true
            }
        },
        created() {
            // let appId = "wx33c2b97fed6ed8c5";
            let appId = "wxfc1464621ee4a57b";
            // try{
                // 如果用户没有登录，去获取微信信息，然后跳转到绑定页面
                // const user = this.$store.state.AuthedUser;
                // if(!user){
                    // 跳转到公众号验证页面
                    window.location.replace('http://open.weixin.qq.com/connect/oauth2/authorize'+
                        '?appid='+appId+
                        '&redirect_uri=https://jlyw.hebjlzy.com/mp/code'+
                        '&response_type=code'+
                        '&scope=snsapi_userinfo'+
                        '#wechat_redirect'
                    );
                // } else {
                //     this.$router.push('/mp/index');
                // }
            // }catch (e) {
            //     跳转到公众号验证页面
            //     window.location.replace('http://open.weixin.qq.com/connect/oauth2/authorize'+
            //         '?appid='+appId+
            //         '&redirect_uri=http://yunsong100.com/mp/code'+
            //         '&response_type=code'+
            //         '&scope=snsapi_userinfo '+
            //         '#wechat_redirect');
            // }
        }
    }
</script>

<style scoped>

</style>